import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../core/http.service';
import { Project } from '../models/project';



@Injectable({
    providedIn: 'root'
})
export class ProjectService {

    constructor(
        private httpService: HttpService
    ) {
        
    }

    public list(params: any) : Observable<Project[]> {
        console.debug('params', params);
        
        return this.httpService.get('/project', params);
    }
    
    public get(id: number, params: any){
        return this.httpService.get(`/project/${id}`, params);
    }
    
    public main() : Observable<Project[]> {
        return this.httpService.get('/project/main');
    }

}
